/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';

/**
 * Steam authentication mixin.
 *
 * Provides basic parameter definition getters.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class SteamAuth extends Vue {
    /**
     * Get redirection url (used as part of the steam and UGC api auth process).
     *
     * @returns {string}
     */
    get redirectUrl(): string {
        return window.location.origin + '/login/authenticate';
    }

    /**
     * Get steam url.
     *
     * @returns {string}
     */
    get steamUrl(): string {
        const params: string[] = [
            'gameId=493340',
            'callback=' + this.redirectUrl,
        ];

        return 'https://auth.frontierstore.net/steam?' + params.join('&');
    }
}

